import React from "react";

// Combined matcher — either form becomes a clickable <a>:
//   1. Markdown link:  [label](https://...)   → anchor text = label
//   2. Bare URL:       https://...            → anchor text = the URL
// Bare-URL form stops at whitespace and common trailing punctuation
// (.,;:!?)] so a URL at the end of a sentence isn't eaten.
const LINK_RE =
  /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>"']+?)(?=[).,;:!?\]]*(?:\s|$))/g;

/**
 * Split a string on links and return an array of React nodes — plain
 * text slices interleaved with <a> tags. Used by chat-bubble renderers
 * so operator-pasted or agent-generated links are clickable. Accepts
 * both bare URLs and markdown-style `[label](url)` so messages can
 * carry friendly anchor text (e.g. "Download now") instead of a long
 * raw Tailscale URL.
 */
export function linkifyText(text: string, keyPrefix = ""): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  let lastIdx = 0;
  let match: RegExpExecArray | null;
  LINK_RE.lastIndex = 0;
  while ((match = LINK_RE.exec(text)) !== null) {
    if (match.index > lastIdx) {
      parts.push(text.slice(lastIdx, match.index));
    }
    const isMdLink = match[1] !== undefined && match[2] !== undefined;
    const url = isMdLink ? match[2] : match[3];
    const label = isMdLink ? match[1] : url;
    parts.push(
      <a
        key={`${keyPrefix}lnk-${match.index}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:opacity-80"
      >
        {label}
      </a>
    );
    lastIdx = match.index + match[0].length;
  }
  if (lastIdx < text.length) {
    parts.push(text.slice(lastIdx));
  }
  return parts.length > 0 ? parts : [text];
}
